import { Suspense, useState , useEffect , useRef} from 'react';
import AppLoading from '../app-loading/app-loading';
import reportsServices from '../../services/reports/reportservice';
import POSTargetMappingListDataTable from './pos-target-mapping-datatable';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from "primereact/toast";

const POSTargetMappingList = () => {

    const toast = useRef<Toast>(null);
    const [loading, setLoading] = useState(false);
    const [dataList,setDataList] = useState<any>([]);
    const today = new Date();
    const [year,setYear] = useState<any>(today.getFullYear());
    const [month,setMonth] = useState<any>(today.getMonth() + 1 );
    const monthNames = [ 
    {"id" : 1,"month" :"January"},
    {"id" : 2,"month" :"February"},
    {"id" : 3,"month" :"March"},
    {"id" : 4,"month" :"April"},
    {"id" : 5,"month" :"May"},
    {"id" : 6,"month" :"June"},
    {"id" : 7,"month" :"July"},
    {"id" : 8,"month" :"August"},
    {"id" : 9,"month" :"September"},
    {"id" : 10,"month" :"October"},
    {"id" : 11,"month" :"November"},
    {"id" : 12,"month" :"December"}
    ]
    const [selectedMonth, setSelectedMonth] = useState<any>(monthNames.filter(x => x.id === month)[0]);

    useEffect(() => {
           handelSearch();
    }, []);

    function handelSearch(monthId = selectedMonth.id){
        if(year !== "" && year !== null)
            {
                setLoading(true);
                var data = {
                    "year" : year,
                    "month" : monthId
                }
                reportsServices.gstPOSTargetMapping(data).then((response: any[]) => {
                    setDataList(response);
                    setLoading(false);
                });
            }
            else{
                toast.current?.show({
                     severity: 'info',
                    summary: 'Info',
                    detail: 'Please input the year',
                    life: 3000
                });
                return;
            }
    }


    return (
        <Suspense fallback={<AppLoading />}>
            <Toast ref={toast} />
            <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
                <div className="col-12">                
                    <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
                        <h5 className="ml-1 mb-0">POS Target Mapping</h5>
                    </div>
                </div>
                <div className='grid'>
                    <div className="col-12 sm:col-6 lg:col-4 font-bold text-white border-round">
                        <InputText
                            id="Year"
                            name="Year"
                            keyfilter="int"
                            value={year}
                            onChange={(e) => setYear(e.target.value)}
                            placeholder={year + "#"} style={{ width: "100%" }}
                            disabled
                        />
                    </div>
                    <div className="col-12 sm:col-6 lg:col-4 font-bold text-white border-round">
                        <Dropdown value={selectedMonth} onChange={(e) => {
                            setSelectedMonth(e.value);
                            handelSearch(e.value.id);
                        }} options={monthNames} optionLabel="month"
                         placeholder="Select a Month"  />
                    </div>
                </div>
                <POSTargetMappingListDataTable data={dataList} selectedMonth={selectedMonth?.id} selectedYear={year} />
            </div>
            {loading && <AppLoading />}
        </Suspense>
    );
};

export default POSTargetMappingList;
